import { Component, OnInit } from '@angular/core';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-swiper-why-study',
    templateUrl: './swiper-why-study.component.html',
    styleUrls: ['./swiper-why-study.component.scss']
})
export class SwiperWhyStudyComponent implements OnInit {

    // A swiper config which is responsive and shows partial slides

    public responsivePartialOverflowConfig: any = {
        slidesPerView: 1.2,
        spaceBetween: 15,
        freeMode: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        pagination: { clickable: true },
        breakpoints: {
            576: {
                slidesPerView: 2.2
            },
            768: {
                slidesPerView: 3.2
            },
            992: {
                slidesPerView: 4
            }
        }
    };

    constructor() { }

    ngOnInit(): void {
    }

    /**
     * When 'Why Study with us' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onWhyStudySwiper(swiper) {

        setTimeout(() => {
            // swiper.update();
        }, 1500);

    }

}
